// components/generic/FeatureBenefitsList/FeatureBenefitsList.tsx
import React from "react";
import { Stack, Group, Text, ThemeIcon, Alert } from "@mantine/core";
import { IconCheck, IconInfoCircle } from "@tabler/icons-react";

export interface FeatureBenefit {
  text: string;
  icon?: React.ReactNode;
}

export interface FeatureNotice {
  title?: string;
  message: string;
  color?: string;
  icon?: React.ReactNode;
}

export interface FeatureBenefitsListProps {
  benefits: (string | FeatureBenefit)[];
  color?: string;
  /** Optional notice to display at the bottom of the benefits list */
  notice?: FeatureNotice;
  /** Optional custom content to display at the bottom */
  footer?: React.ReactNode;
}

export const FeatureBenefitsList: React.FC<FeatureBenefitsListProps> = ({
  benefits,
  color = "green",
  notice,
  footer,
}) => {
  return (
    <Stack gap="md">
      <Stack gap="sm">
        {benefits.map((benefit, index) => {
          const text = typeof benefit === "string" ? benefit : benefit.text;
          const icon = typeof benefit === "string" ? null : benefit.icon;

          return (
            <Group key={index} gap="sm" align="flex-start">
              <ThemeIcon size="sm" radius="xl" color={color} variant="light">
                {icon || <IconCheck size={14} />}
              </ThemeIcon>
              <Text size="sm" style={{ flex: 1 }}>
                {text}
              </Text>
            </Group>
          );
        })}
      </Stack>

      {notice && (
        <Alert
          icon={notice.icon || <IconInfoCircle size={18} />}
          title={notice.title}
          color={notice.color || "blue"}
          variant="light"
        >
          {notice.message}
        </Alert>
      )}

      {footer}
    </Stack>
  );
};
